import { ProductSelector } from "~/components/product-selector";
import { FC, useEffect } from "react";
import styles from "./product-add-to-cart.module.css";
import { Product } from "~/common/props/orchestrator";
import { ToppingValueDto } from "~/modules/Product/Product.type";
import { UiButton } from "~/components/ui-button";
import { useTranslation } from "react-i18next";
import { ITheme, ProductType } from "@commons-monorepo/index";

type ProductAddToCartProps = {
  product: Product;
  selectedToppings: ToppingValueDto[];
  hasProductInTheCart: boolean;
  offerId?: string;
  disabled?: boolean;
  theme?: ITheme;
  onRequiredTopping?: () => void;
  onGoToCheckoutCart?: () => void;
  onGoToCheckoutPay?: () => void;
};

export const ProductAddToCart: FC<ProductAddToCartProps> = ({
  product,
  selectedToppings,
  hasProductInTheCart,
  offerId,
  disabled,
  theme,
  onRequiredTopping,
  onGoToCheckoutCart,
  onGoToCheckoutPay
}) => {
  const { t } = useTranslation();

  const handleRequiredTopping = () => {
    onRequiredTopping && onRequiredTopping();
  };

  const handleGoToCheckoutCart = () => {
    onGoToCheckoutCart && onGoToCheckoutCart();
  };

  const handleGoToCheckoutPay = () => {
    onGoToCheckoutPay && onGoToCheckoutPay();
  };

  return (
    <div className={styles.productAddToCart}>
      <div className={styles.productAddToCartOption}>
        <ProductSelector
          product={product}
          offerId={offerId}
          selectedToppings={selectedToppings}
          disable={disabled}
          addProductLabel={t("button.add_to_cart")}
          onRequiredTopping={handleRequiredTopping} />

      </div>
      {product.type !== ProductType.Service &&
      <>
          {hasProductInTheCart &&
        <UiButton
          isFilled
          hasPersonalization
          rightIcon={
          <span className={theme?.config.button?.icon || "icon-cart"} />}

          className={`${styles.productAddToCartOption}`}
          onClick={handleGoToCheckoutCart}>

              {t("button.goTo")}
            </UiButton>}

          <UiButton
          isSecondary
          className={`${styles.productAddToCartOption} ${styles.buyNow}`}
          onClick={handleGoToCheckoutPay}
          disabled={!hasProductInTheCart && disabled}>

            {t("button.payment")}
          </UiButton>
        </>}

    </div>);

};